module.exports = __webpack_public_path__ + "static/horde1opac1-72895d8ae3e2449633940b00e7f79afe.png";